module.exports = __webpack_public_path__ + "static/media/JourneyToTheWest.7608ee43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/tc/JourneyToTheWest.png
// module id = 1142
// module chunks = 0